import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ValidationTextFieldColor } from 'src/utils/theme';

import { InputStatus } from './Input.interface';

export const ValidationTextField = styled('input', {
  shouldForwardProp: (prop: any) => prop !== 'status',
})<{ status?: InputStatus }>(
  ({ status, theme }) => `
  width: 100%;
  height: 2.75rem;
  background: ${theme.palette.secondary.lighter};
  padding: 12px 16px;
  border: 1px solid ${ValidationTextFieldColor(status)};
  border-radius: 4px;
`,
);

export const InputTextLabel = styled(Typography)<{ status?: InputStatus }>(
  ({ status, theme }) => `
  font-weight: 400;
  ${getInputColorField(status, theme)}
`,
);

export const getInputColorField = (status: InputStatus, theme: any) => {
  switch (status) {
    case InputStatus.ERROR:
      return `color: ${theme.palette.brand.red};`;
    case InputStatus.DISABLED:
      return `color: ${theme.palette.brand?.disable};`;
    default:
      return '';
  }
};
